module.exports = __webpack_public_path__ + "static/carousel_1-e9b9c70b233760e361581e27d94c8b5e.jpg";